import { SKIP_TO_MAIN_CONTENT_ANCHOR } from '@portals/root/src/components/HeaderBar/HeaderBar.constants';
import React, { KeyboardEventHandler, MouseEventHandler } from 'react';

const scrollToMainContent = (): void => {
  const refElement = document?.getElementById(SKIP_TO_MAIN_CONTENT_ANCHOR);
  if (refElement) {
    // eslint-disable-next-line @if6/fi-no-location
    window.location.hash = `#${SKIP_TO_MAIN_CONTENT_ANCHOR}`;

    window.scrollTo({
      top: refElement?.offsetTop,
      behavior: 'smooth',
    });
    refElement?.focus({ preventScroll: false });
  }
};

export const skipToMainContentOnClick: MouseEventHandler<HTMLAnchorElement> = (event: React.MouseEvent) => {
  event.preventDefault();
  scrollToMainContent();
};

export const skipToMainContentOnKeyDown: KeyboardEventHandler<HTMLAnchorElement> = (event: React.KeyboardEvent) => {
  if (event.key === 'Enter') {
    scrollToMainContent();
  }
};
